export enum ProjectPermission {
    owner = "Owner",
    editor = "Editor",
    unassigned = "",
}

export enum ProjectUserType {
    user = "User",
    group = "Group",
}